// components
import { IconButton } from '@mui/material';
import useSettings from '../../../hooks/useSettings';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

export default function ThemesPopover() {
  const { themeMode, onChangeMode } = useSettings();
  return (
    <>
      <IconButtonAnimate color={'primary'} sx={{ width: 40, height: 40 }}>
        <IconButton
          onClick={() => {
            onChangeMode(themeMode === 'light' ? 'dark' : 'light');
          }}
        >
          <Iconify icon={themeMode === 'light' ? 'ph:sun-duotone' : 'ph:moon-duotone'} width={20} height={20} />
        </IconButton>
      </IconButtonAnimate>
    </>
  );
}
